var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDauMau(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.206,
    height: 38,
    viewBox: "0 0 38.206 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dau_mau",
    "data-name": "dau/mau",
    transform: "translate(0.206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 38,
    height: 38,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Day",
    transform: "translate(0 13.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M174.177,82.147a7.919,7.919,0,1,1-7.918-7.918A7.918,7.918,0,0,1,174.177,82.147Z",
    transform: "translate(-154.584 -70.4)",
    fill: "#65b0f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M112.743,192.033h2.374c.167,0,.314-.22.314-.459s-.147-.446-.314-.446H113.37v-.06c0-.606,2.061-1.078,2.061-2.522a1.439,1.439,0,0,0-1.554-1.377,1.38,1.38,0,0,0-1.507,1.278c0,.419.2.539.467.539.34,0,.547-.186.547-.379a.455.455,0,0,1,.5-.5.462.462,0,0,1,.507.473c0,.845-2.1,1.444-2.1,2.489v.646C112.289,191.906,112.556,192.033,112.743,192.033Zm0,0",
    transform: "translate(-105.92 -178.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M204.905,191h1.561v.706c0,.213.26.319.52.319s.52-.106.52-.319V191h.287c.16,0,.32-.24.32-.479s-.107-.479-.32-.479h-.287v-.466c0-.22-.26-.313-.52-.313s-.52.093-.52.313v.466h-.574l1.181-2.363a.324.324,0,0,0,.033-.126c0-.24-.34-.393-.52-.393a.469.469,0,0,0-.433.266l-1.541,3.015a.426.426,0,0,0-.053.2A.332.332,0,0,0,204.905,191Zm0,0",
    transform: "translate(-194.775 -178.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M316.084,184.109c-.3,0-.514.126-.514.313v4.346c0,.16.213.32.514.32.28,0,.52-.16.52-.32v-1.491a.469.469,0,0,1,.447-.5.509.509,0,0,1,.48.5v1.491c0,.213.273.32.514.32.26,0,.52-.107.52-.32v-1.491a1.3,1.3,0,0,0-1.134-1.4.9.9,0,0,0-.827.506v-1.963C316.6,184.236,316.364,184.109,316.084,184.109Zm0,0",
    transform: "translate(-301.678 -175.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    d: "M23.4,11.69A11.7,11.7,0,0,0,11.686,0,.686.686,0,0,0,11,.634a.479.479,0,0,0,0,.051h0V2.53a.686.686,0,0,0,1.373,0V1.393a10.332,10.332,0,0,1,9.634,9.613H20.868a.685.685,0,1,0,0,1.37h1.139a10.332,10.332,0,0,1-9.634,9.613V20.851a.686.686,0,0,0-1.373,0v1.157a10.335,10.335,0,0,1-9.605-9.632H2.505a.685.685,0,1,0,0-1.37H1.4q.035-.508.121-1.013A10.367,10.367,0,0,1,2.809,6.466l.116.594a.687.687,0,0,0,.673.554A.694.694,0,0,0,3.73,7.6a.685.685,0,0,0,.543-.8L3.848,4.616a.686.686,0,0,0-.8-.542L.855,4.5a.685.685,0,1,0,.262,1.345l.527-.1A11.652,11.652,0,0,0,.78,15.9a11.72,11.72,0,0,0,10.94,7.5h.014c.061,0,.121,0,.181,0A11.745,11.745,0,0,0,23.4,11.69Zm0,0",
    transform: "translate(0)",
    fill: "#3c4043",
    stroke: "#fff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(17.566 7.978)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 2.871,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 2.773, 1.015)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.871,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 1.015, 0)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(2.902 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#fee96b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    "data-name": "Circle",
    transform: "translate(9.742 9.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#abda7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "translate(29.235 26.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M176.238,72.532l2.1-3.641,2.1,3.641Z",
    transform: "translate(-176.238 -68.891)",
    fill: "none",
    stroke: "#5fb4f6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(23.403 1.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    "data-name": "Path 4445",
    d: "M10.981,1.017H10.32V.508A.508.508,0,1,0,9.3.508v.508H6.99V.508a.508.508,0,1,0-1.017,0v.508H3.686V.508a.508.508,0,0,0-1.017,0v.508H2.033A2.036,2.036,0,0,0,0,3.05v7.93a2.036,2.036,0,0,0,2.033,2.033H5.922a.508.508,0,0,0,0-1.017H2.033a1.018,1.018,0,0,1-1.017-1.017V3.05A1.018,1.018,0,0,1,2.033,2.033h.635v.508a.508.508,0,0,0,1.017,0V2.033H5.973v.508a.508.508,0,1,0,1.017,0V2.033H9.3v.508a.508.508,0,1,0,1.017,0V2.033h.661A1.018,1.018,0,0,1,12,3.05v2.9a.508.508,0,0,0,1.017,0V3.05A2.036,2.036,0,0,0,10.981,1.017Z",
    fill: "#3c4043"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_31",
    "data-name": 31,
    transform: "translate(2.597 9.646)",
    fill: "#3c4043",
    fontSize: 7,
    fontFamily: "Nunito-Bold, Nunito",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "31")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDauMau);
export default __webpack_public_path__ + "static/media/dau-mau.92c727a1de7c96d47f4f3c4470fed8af.svg";
export { ForwardRef as ReactComponent };